export default __webpack_public_path__ + "static/media/logo-ifs-broker.30b1a2ba.svg";